import { render, staticRenderFns } from "./form-section.vue?vue&type=template&id=2554aefe"
import script from "./form-section.vue?vue&type=script&lang=js"
export * from "./form-section.vue?vue&type=script&lang=js"
import style0 from "./form-section.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports